import { getAnalytics } from "firebase/analytics";
import { initializeApp } from "firebase/app";
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCa1gsMc6HCoQcsIUIFvDV2Fx3A8rpWMsg",
  authDomain: "afl-match-tracker.firebaseapp.com",
  projectId: "afl-match-tracker",
  storageBucket: "afl-match-tracker.firebasestorage.app",
  messagingSenderId: "187140274859",
  appId: "1:187140274859:web:85801198b8091f143655ee",
  measurementId: "G-Z67RL4LDXD"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
export const db = getFirestore()
